import { useState, useMemo, useCallback, useEffect } from 'react';

// TODO: refactor to separate hooks for readability
export function useFeaturesFilter({
  config,
  query,
  setFilters,
  updateQuery,
}) {
  let defaultValue = useMemo(() => {
    let value = {};

    for (let feature of query.features || []) {
      value[feature] = true;
    }

    return value;
  }, []);

  let [ features, setFeatures ] = useState(defaultValue);

  let featuresOptions = useMemo(() => {
    let list = {};

    for (let feature of config.featureOptions?.multiBinary || []) {
      list[feature.name] = [];

      for (let option of feature.options) {
        list[feature.name].push({
          ...option,
          isChecked: features[option.value]
        });
      }
    }

    return list;
  }, [features]);

  let onFeatureToggle = useCallback((featureOption) => {
    setFeatures(x => ({ ...x, [featureOption.value]: !featureOption.isChecked }));
  }, []);

  let onFeatureChange = useCallback((isChecked, feature) => {
    setFeatures(x => ({ ...x, [feature]: isChecked }));
  }, []);

  useEffect(() => {
    let specified = {};
    let tags = [];
    let defaultJoinWith = '+';

    for (let feature of config.featureOptions?.binary || []) {
        let { value, tag } = feature;

        specified[value] = true;

        if (features[value]) {
          tags.push(tag || value);
        } else if (feature.withNegative) {
          tags.push(`-${tag || value}`)
        }
    }

    for (let group of config.featureOptions?.multiBinary || []) {
      let groupTags = [];
      let joinWith = group.joinWith || defaultJoinWith;

      for (let feature of group.options) {
        let { value, tag } = feature;

        specified[value] = true;

        if (features[value]) {
          groupTags.push(tag || value);
        }
      }

      let tag = groupTags.join(joinWith);

      if (tag) {
        tags.push(tag);
      }
   }

    let customTags = Object.keys(features).filter(x => !specified[x]);

    tags.push(...customTags);

    setFilters(x => ({ ...x, features: tags.join(',') || null }));

    updateQuery({ features: Object.keys(features).filter(x => features[x]).join(',') || undefined });
  }, [features]);

  return {
    features,
    featuresOptions,
    onFeatureToggle,
    onFeatureChange,
  };
}
